export default __webpack_public_path__ + "static/media/avatar.44c7f3db.png";